import { RollbackOutlined } from "@ant-design/icons"
import { Button, Divider, Popover, Select, Space, Table, Typography, message } from "antd"
import moment from "moment"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { collection, deleteDoc, doc, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { useAuthContext } from "../../../hooks/useAuthContext"

const { Title, Text, Link } = Typography

export default function SentBackOrders() {
  const { user } = useAuthContext()

  const [sentBackPrices, setSentBackPrices] = useState([])
  const [pricesLoading, setPricesLoading] = useState(false)
  const [selectedLink, setSelectedLink] = useState(`/orders/sent-back`)

  //gets the data
  useEffect(() => {
    setPricesLoading(true)
    const pricesRef = collection(db, "orders")
    let priceQ = query(
      pricesRef,
      where("uid", "==", user.uid),
      where("orderStatus", "==", 0),
      where("orderForAdmin", "==", false)
    )

    const unsubscribe = onSnapshot(priceQ, (snapshot) => {
      const doneOrders = snapshot.docs.map((doc) => ({
        id: doc.id, // include the document ID here
        ...doc.data(),
      }))
      console.log(doneOrders)
      setSentBackPrices(doneOrders)
      setPricesLoading(false)
    })

    return () => {
      unsubscribe()
    }
  }, [user])

  const navigate = useNavigate()

  //handle remove order
  const removeOrder = async (id) => {
    const ref = doc(db, "orders", id)
    try {
      deleteDoc(ref).then(() => {
        message.success("vendor removed!")
      })
    } catch (err) {
      message.error(err)
    }
  }

  const returnSelected = (val) => {
    //passes the state and changes link based on selected option
    const handleClick = () => {
      navigate(selectedLink, { state: val })
    }

    //returns element of select + button
    return (
      <>
        <Space>
          <Space.Compact block size="small">
            <Select
              style={{ width: "70%" }}
              onChange={(value) => setSelectedLink(value)}
              options={[
                {
                  value: `/calculations`,
                  label: "Re-Calculate",
                },
              ]}
            />
            <Button onClick={handleClick} type="primary">
              Send
            </Button>
          </Space.Compact>
          <Button danger size="small" type="primary" onClick={() => removeOrder(val.id)}>
            Remove
          </Button>
        </Space>
      </>
    )
  }

  //default columns for table
  const defaultColumns = [
    {
      title: "Client",
      dataIndex: ["client", "client"],
      align: "center",
    },
    {
      title: "Product",
      dataIndex: ["selectedProduct", "product", "productName"],
      align: "center",
    },
    {
      title: "Sent Back By",
      dataIndex: "updatedByEmail",
      align: "center",
    },
    {
      title: "Comment",
      dataIndex: "designerComment",
      align: "center",
      render: (text) => (
        <Popover content={popoverContent(text)} title="Designer Comment" trigger="click">
          <Link>comment</Link>
        </Popover>
      ),
    },
    {
      title: "Date",
      dataIndex: "updated",
      align: "center",
      sorter: (a, b) => a.date.updated.seconds - b.date.updated.seconds,
      render: (value) => (
        <>
          <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
        </>
      ),
    },
    {
      title: "Action",
      align: "center",
      width: "20%",
      render: (value) => <>{returnSelected(value)}</>,
    },
  ]

  const popoverContent = (value) => {
    return (
      <>
        <Text>{value}</Text>
      </>
    )
  }

  return (
    <div>
      <Title level={3}>
        <RollbackOutlined />
        <Divider type="vertical" />
        Sent Back Orders
      </Title>
      <Table
        style={{ marginTop: "15px" }}
        size="small"
        loading={pricesLoading}
        columns={defaultColumns}
        dataSource={sentBackPrices}
        rowKey={(record) => record.id}
        pagination={{ defaultPageSize: "12", showSizeChanger: true }}
      />
    </div>
  )
}
